import http from '@/http';

const mediaService = {
  // Lấy danh sách media có phân trang
  getMediaList(params = {}) {
    return http.get('/admin/media', { params });
  },

  // Lấy thông tin media theo ID
  getMediaById(id) {
    return http.get(`/admin/media/${id}`);
  },

  // Upload media mới
  uploadMedia(formData) {
    return http.post('/admin/media/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  // Cập nhật thông tin media
  updateMedia(id, data) {
    return http.put(`/admin/media/${id}`, data);
  },

  // Xóa media
  deleteMedia(id) {
    return http.delete(`/admin/media/${id}`);
  },

  // Lấy thống kê media
  getMediaStats() {
    return http.get('/admin/media/stats/overview');
  }
};

export default mediaService;
